import React from "react";
import "../Styles/Feefrequency.css";

export default function Sports() {
  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Sports</h4>
      </div>

      <div className="ff-page-body">
        <div className="card ff-detail-card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table ff-detail-table mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold ff-detail-label">Category Name</td>
                    <td>Sports</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Category Type</td>
                    <td>Fee</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Amount Type</td>
                    <td>Amount</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Applicable To</td>
                    <td>All</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Category Status</td>
                    <td>Active</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
